var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.step === 'step1')?_c('div',[_c('Step1',{on:{"goStep2":_vm.goStep2}})],1):_vm._e(),(_vm.step === 'step2')?_c('div',[_c('Step2',{on:{"goStep1":_vm.goStep1}})],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }